<template>
  <div class="recycle-one-stop-ka" ref="recycleOneStop">
    <div class="main-wrap">
      <div class="left">
        <div class="p1">
          <img class="pic" v-lazy="oneStopAct.oldModelImage" alt="" />
          <span class="label">旧机</span>
        </div>
        <div class="p2">
          <v-icon :name="switchName"></v-icon>
        </div>
        <div class="p3">
          <img class="pic" v-lazy="newModelImg" alt="" />
          <span class="label">新机</span>
        </div>
      </div>
      <div class="middle">
        <div class="p1">
          <img class="title" v-lazy="imgOneStopLogo" />
          <img v-if="levelIconWithTextUrl" :src="levelIconWithTextUrl" class="member-level-icon"/>
        </div>
        <div class="p2" :class="[largeWidth ? 'big-width' : '']" v-html="desc"></div>
      </div>
    </div>
    <div class="action" @click="goToRenew">
      <v-button size="small" type="frame">去换新</v-button>
      <!-- <span>去换新</span> -->
    </div>
  </div>
</template>

<script>
import { app } from '@/utils'
import { mapGetters, mapMutations } from 'vuex'
import { formatNumber } from '@/utils/common'

// 深色模式适配
const darkMixin = {
  data() {
    return {
      // 是否自定义深色模式
      isDark: app.getColorScheme()
    }
  },

  computed: {
    switchName() {
      const { isDark } = this
      if (!isDark) return 'icon-switch-light'
      else return 'icon-switch'
    },

    imgOneStopLogo() {
      const { isDark } = this
      if (!isDark) return require('../../images/one-stop-title-light.png')
      else return require('../../images/one-stop-title-dark.png')
    }
  }
}

// 响应式适配
const folderMixin = {
  data() {
    return {
      // 容器宽度
      containerWidth: 0,
      // 是不是大宽度设备
      largeWidth: false
    }
  },

  watch: {
    containerWidth(newWidth, oldWidth) {
      if (newWidth > 430) this.largeWidth = true
      else this.largeWidth = false
    }
  },

  mounted() {
    this.containerWidth = this.$refs.recycleOneStop.offsetWidth
    window.addEventListener('resize', this.handleResize)
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },

  methods: {
    handleResize() {
      this.containerWidth = this.$refs.recycleOneStop.offsetWidth
    }
  }
}

export default {
  name: 'RecycleOneStop',
  props: ['oneStopAct'],
  mixins: [darkMixin, folderMixin],

  computed: {
    ...mapGetters('detailv3', ['newModelImg', 'totalEstimatedPrice']),
    // 价格逻辑 大于等于 0 取 0、 小于 0 取绝对值
    price() {
      const { totalEstimatedPrice } = this
      const { recyclePrice, recycleReward } = this.oneStopAct
      let re = Number(totalEstimatedPrice) - Number(recyclePrice) - Number(recycleReward)
      return formatNumber(re)
    },

    // 一站式换新补贴文案
    desc() {
      const { price } = this
      if (price > 0) return `预估换新仅需<span class="yuan">${price}</span>元`
      else if (price == 0) return `0元购新机`
      else return `0元购机,预估再得<span class="yuan">${Math.abs(price)}</span>元`
    },

    // 会员等级
    memberLevel() {
      return this.oneStopAct?.memberLevel
    },
    // 会员等级图片
    levelIconWithTextUrl() {
      return this.oneStopAct?.levelIconWithTextUrl
    }
  },

  mounted() {
    this['ONE_STOP_RECYCLE_VISIBILITY'](false)
    this.$nextTick(() => {
      this.IO = new IntersectionObserver(
        entries => {
          if (entries[0].intersectionRatio > 0.5) {
            this['ONE_STOP_RECYCLE_VISIBILITY'](false)
          } else {
            this['ONE_STOP_RECYCLE_VISIBILITY'](true)
          }
        },
        { threshold: [0.5] }
      )
      this.IO.observe(document.querySelector('.recycle-one-stop-ka'))
    })
  },

  methods: {
    ...mapMutations('detailv3', ['ONE_STOP_RECYCLE_VISIBILITY']),
    goToRenew() {
      this.$emit('goToRenew')
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>
<style lang="scss" scoped>
.vivo-fontscale-5 {
  .recycle-one-stop-ka {
    .middle {
      margin-left: 3px;
    }
    .action {
      font-size: 29px;
    }
  }
}

.vivo-fontscale-4 {
  .recycle-one-stop-ka {
    .action {
      font-size: 32px;
    }
  }
}
</style>
